
import { LayoutDirective } from './layout.directive';
import { LayoutAlignDirective } from './layout-align.directive';
import { LayoutGapDirective } from './layout-gap.directive';
import { NgModule } from '@angular/core';


@NgModule({
    declarations: [
        LayoutDirective,
        LayoutAlignDirective,
        LayoutGapDirective
    ],
    exports: [
        LayoutDirective,
        LayoutAlignDirective,
        LayoutGapDirective
    ]
})
export class LayoutModule { }